import { render, staticRenderFns } from "./CallMarketplaceToCancelOrder.vue?vue&type=template&id=1f9f9db1"
import script from "./CallMarketplaceToCancelOrder.vue?vue&type=script&lang=ts"
export * from "./CallMarketplaceToCancelOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports